import { BUTTON_PRESS } from './baseEvents'

const DEVICES_BULK = 'Devices - Bulk'

// Row / select-all selection
export const DEVICES_BULK_SELECT_DEVICE = `${BUTTON_PRESS} ${DEVICES_BULK} - Select Device`
export const DEVICES_BULK_SELECT_ALL = `${BUTTON_PRESS} ${DEVICES_BULK} - Select All`
export const DEVICES_BULK_CLEAR_SELECTION = `${BUTTON_PRESS} ${DEVICES_BULK} - Clear Selection`

// Bulk label flow
export const DEVICES_BULK_LABEL_OPEN = `${BUTTON_PRESS} ${DEVICES_BULK} - Open Label Menu`
export const DEVICES_BULK_LABEL_SELECT_INTENT = `${BUTTON_PRESS} ${DEVICES_BULK} - Label Intent`
export const DEVICES_BULK_LABEL_APPLY_SUCCESS = `${DEVICES_BULK} - Label Apply - Success`
export const DEVICES_BULK_LABEL_APPLY_FAILURE = `${DEVICES_BULK} - Label Apply - Failure`

// Camera-only bulk actions reject a selection containing non-cameras with an
// error toast. An outcome rather than an interaction, so no BUTTON_PRESS prefix.
// Shared by every such action — the `bulk_action` property says which one.
export const DEVICES_BULK_NON_CAMERA_SELECTION_ERROR = `${DEVICES_BULK} - Non-Camera Selection Error`

// Bulk stream account flow (streamingType + externalAccountId)
export const DEVICES_BULK_STREAM_ACCOUNT_OPEN = `${BUTTON_PRESS} ${DEVICES_BULK} - Open Stream Account Modal`
export const DEVICES_BULK_STREAM_ACCOUNT_APPLY_SUCCESS = `${DEVICES_BULK} - Stream Account Apply - Success`
export const DEVICES_BULK_STREAM_ACCOUNT_APPLY_FAILURE = `${DEVICES_BULK} - Stream Account Apply - Failure`

// Bulk delete flow
export const DEVICES_BULK_DELETE_OPEN = `${BUTTON_PRESS} ${DEVICES_BULK} - Open Delete Modal`
export const DEVICES_BULK_DELETE_CONFIRM = `${BUTTON_PRESS} ${DEVICES_BULK} - Confirm Delete`
export const DEVICES_BULK_DELETE_CANCEL = `${BUTTON_PRESS} ${DEVICES_BULK} - Cancel Delete`
export const DEVICES_BULK_DELETE_SUCCESS = `${DEVICES_BULK} - Delete - Success`
export const DEVICES_BULK_DELETE_FAILURE = `${DEVICES_BULK} - Delete - Failure`
